import { Component, ObjectManager } from '../../../concepts/objects';
import { resolve } from '../../Container';
import { JiraCard } from '../atlassian/JiraCard';
import { DefineSimpleDimension } from '../dataExport/addons/SimpleDimension';
import { FromFirstMatchExportAdapter } from '../dataExport/ExportAdapter';
import { IndexCard } from '../paper/IndexCard';
import { Sticky } from '../paper/Sticky';
import { TaskCard } from '../paper/TaskCard';
import { Zone } from './Zone';
import { ZoneAssocation } from './ZoneAssociations';

export class StickyInZoneExportAdapter extends FromFirstMatchExportAdapter {

    @resolve(ObjectManager) private objects!: ObjectManager;

    protected selector = (c: Component) => c.is(Sticky) || c.is(TaskCard) || c.is(IndexCard) || c.is(JiraCard);

    public readonly id = 'StickyInZoneAssociations';
    public readonly label = 'Associations';
    public readonly defaults = true;
    public readonly columns = [
        DefineSimpleDimension(
            Component,
            'Zone',
            'Adds a column that contains the title of the Zone that each object is assigned to.',
            (c: Component) => {
                const id = ZoneAssocation.get(c);
                const zone = this.objects.getMaybe(id, Zone);
                return zone?.title ?? null;
            }
        ),
    ];
}

// export class TaskCardInZoneExportAdapter extends FromFirstMatchExportAdapter {

//     @resolve(ObjectManager) private objects!: ObjectManager;

//     protected selector = (c: Component) => c.is(TaskCard);

//     public readonly id = 'TaskCardInZoneAssociations';
//     public readonly label = 'Associations';
//     public readonly columns = [
//         DefineSimpleDimension(
//             TaskCard,
//             'Zone',
//             'Adds a column that contains the title of the Zone that each object is assigned to.',
//             (c: Component) => {
//                 const id = ZoneAssocation.get(c);
//                 const zone = this.objects.getMaybe(id, Zone);
//                 return zone?.title ?? null;
//             }
//         ),
//     ];
// }

// export class IndexCardInZoneExportAdapter extends FromFirstMatchExportAdapter {

//     @resolve(ObjectManager) private objects!: ObjectManager;

//     protected selector = (c: Component) => c.is(IndexCard);

//     public readonly id = 'IndexCardInZoneAssociations';
//     public readonly label = 'Associations';
//     public readonly columns = [
//         DefineSimpleDimension(
//             IndexCard,
//             'Zone',
//             'Adds a column that contains the title of the Zone that each object is assigned to.',
//             (c: Component) => {
//                 const id = ZoneAssocation.get(c);
//                 const zone = this.objects.getMaybe(id, Zone);
//                 return zone?.title ?? null;
//             }
//         ),
//     ];
// }

// export class JiraCardInZoneExportAdapter extends FromFirstMatchExportAdapter {

//     @resolve(ObjectManager) private objects!: ObjectManager;

//     protected selector = (c: Component) => c.is(JiraCard);

//     public readonly id = 'JiraCardInZoneAssociations';
//     public readonly label = 'Associations';
//     public readonly columns = [
//         DefineSimpleDimension(
//             JiraCard,
//             'Zone',
//             'Adds a column that contains the title of the Zone that each object is assigned to.',
//             (c: Component) => {
//                 const id = ZoneAssocation.get(c);
//                 const zone = this.objects.getMaybe(id, Zone);
//                 return zone?.title ?? null;
//             }
//         ),
//     ];
// }
